var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sheet',{staticClass:"container"},[_c('span',{staticClass:"warning hidden-sm-and-down"},[_vm._v("WARNING!")]),_c('span',{staticClass:"warning sm hidden-md-and-up"},[_vm._v("WARNING!")]),_c('h1',[_vm._v("403")]),_c('h3',[_vm._v("您的權限不足!!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }